import { z } from 'zod';

export const PackTier1 = 'super';
export const PackTier2 = 'mega';
export const PackTier3 = 'ultra';
export const PackTier4 = 'infinity';

export const PACK_TIERS = z.enum([PackTier1, PackTier2, PackTier3, PackTier4]);

export const CATEGORY_BASEBALL = 'baseball';
export const CATEGORY_BASKETBALL = 'basketball';
export const CATEGORY_FOOTBALL = 'football';
export const CATEGORY_MULTISPORT = 'multisport';
export const CATEGORY_POKEMON = 'pokemon';
